export default "__VITE_ASSET__Bn1g7FXU__"